export default __webpack_public_path__ + "static/media/5.3Vid.ca8a94a6.mp4";